import BigNumber from "bignumber.js";
import { useTokenHelpers } from "./useTokenHelpers";
import { writeContract, waitForTransactionReceipt } from "@wagmi/core";
import { config as wagmiConfig } from "../../wagmi.config";
import AutoRouter from "../assets/abi/swap/AutoRouter.json";
import ERC20ABI from "../assets/abi/farm/ERC20.json";
import config from "../config";
import useLazyReadContractAsync from "./useLazyReadContractAsync";
import { ethers } from "ethers";

const noOp = () => {};
const noOp1 = (v: any) => {};
const noOp2 = (v: any) => {};

const autorouteAddress = config.autoRouterContractAddress?.startsWith("0x")
  ? config.autoRouterContractAddress
  : "0x0000000000000000000000000000000000000000";

const useSwapHelpers = () => {
  const { lazyReadContract } = useLazyReadContractAsync();

  const { approveTokenToSpender, getAllowance } = useTokenHelpers();

  const myFixed = (x: string, d: number) => {
    if (!d) return BigNumber(x).toFixed(d);
    return BigNumber(x)
      .toFixed(d)
      .replace(/\.?0+$/, "");
  };

  const tooltipDynamicFee = (tradingFee: string, symbol: string) => {
    const tradingFeeStr = `(${myFixed(tradingFee, 18)} ${symbol})`;
    const percentLPStr = "80%";
    const percentPlatformStr = "20%";
    const toolTip = `A portion of each trade ${tradingFeeStr.bold()} which 
        <br/> ${percentLPStr.bold()} will go to liquidity providers(LPs) and 
        <br/> ${percentPlatformStr.bold()} will go to platform.`;
    return toolTip;
  };

  const swapExactNativeForTokens = async (
    nativeAmount: string,
    amountOutMin: string,
    tokenAddressInList: string[],
    ownerAddress: string,
    trxDeadline: string,
    poolType: string,
    dmmPoolAddresses: string[],
    { onError = noOp, onReceipt = noOp2, onTransactionHash = noOp1 }
  ) => {
    try {
      const hash = await writeContract(wagmiConfig, {
        abi: AutoRouter,
        value: BigInt(nativeAmount),
        address: autorouteAddress as `0x${string}`,
        functionName: "swapExactNativeForTokens",
        args: [
          BigInt(amountOutMin),
          tokenAddressInList,
          poolType,
          dmmPoolAddresses,
          ownerAddress as `0x${string}`,
          BigInt(trxDeadline),
        ],
      });

      onTransactionHash(hash);
      
      // Wait for the transaction to be mined
      const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });
      
      onReceipt({ transactionHash: receipt.transactionHash, status: receipt.status === "success" });

      return { transactionHash: receipt.transactionHash, status: receipt.status === "success" };
    } catch (error) {
      onError();
      throw error;
    }
    // await ethereum.contracts.autoRouter.methods
    //   .swapExactNativeForTokens(
    //     amountOutMin,
    //     tokenAddressInList,
    //     poolType,
    //     dmmPoolAddresses,
    //     ownerAddress,
    //     trxDeadline
    //   )
    //   .send({ from: ownerAddress, value: nativeAmount })
    //   .on("transactionHash", onTransactionHash)
    //   .on("receipt", onReceipt)
    //   .catch(onError);
  };

  const swapExactTokensForNative = async (
    nativeAmount: any,
    amountOutMin: any,
    tokenAddressInList: string[],
    ownerAddress: string,
    trxDeadline: string,
    poolType: string,
    dmmPoolAddresses: string[],
    { onError = noOp, onReceipt = noOp2, onTransactionHash = noOp1 }
  ) => {
    try {
      const hash = await writeContract(wagmiConfig, {
        abi: AutoRouter,
        address: autorouteAddress as `0x${string}`,
        functionName: "swapExactTokensForNative",
        args: [
          BigInt(nativeAmount),
          BigInt(amountOutMin),
          tokenAddressInList,
          poolType,
          dmmPoolAddresses,
          ownerAddress as `0x${string}`,
          BigInt(trxDeadline),
        ],
      });

      onTransactionHash(hash);
      
      // Wait for the transaction to be mined
      const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });
      
      onReceipt({ transactionHash: receipt.transactionHash, status: receipt.status === "success" });

      return { transactionHash: receipt.transactionHash, status: receipt.status === "success" };
    } catch (error) {
      onError();
      throw error;
    }
    // await ethereum.contracts.autoRouter.methods
    //   .swapExactTokensForNative(
    //     nativeAmount,
    //     amountOutMin,
    //     tokenAddressInList,
    //     poolType,
    //     dmmPoolAddresses,
    //     ownerAddress,
    //     trxDeadline
    //   )
    //   .send({ from: ownerAddress })
    //   .on("transactionHash", onTransactionHash)
    //   .on("receipt", onReceipt)
    //   .catch((e: any, a: any) => console.log("error", e, a));
  };

  const swapExactTokensForTokens = async (
    amountIn: string,
    amountOutMin: string,
    tokenAddressInList: string[],
    ownerAddress: string,
    trxDeadline: string,
    poolType: string,
    dmmPoolAddresses: string[],
    { onError = noOp, onReceipt = noOp2, onTransactionHash = noOp1 }
  ) => {
    try {
      const hash = await writeContract(wagmiConfig, {
        abi: AutoRouter,
        address: autorouteAddress as `0x${string}`,
        functionName: "swapExactTokensForTokens",
        args: [
          BigInt(amountIn),
          BigInt(amountOutMin),
          tokenAddressInList,
          poolType,
          dmmPoolAddresses,
          ownerAddress as `0x${string}`,
          BigInt(trxDeadline),
        ],
      });

      onTransactionHash(hash);
      
      // Wait for the transaction to be mined
      const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });
      
      onReceipt({ transactionHash: receipt.transactionHash, status: receipt.status === "success" });
      return { transactionHash: receipt.transactionHash, status: receipt.status === "success" };
    } catch (error) {
      onError();
      throw error;
    }
    // await ethereum.contracts.autoRouter.methods
    //   .swapExactTokensForTokens(
    //     amountIn,
    //     amountOutMin,
    //     tokenAddressInList,
    //     poolType,
    //     dmmPoolAddresses,
    //     ownerAddress,
    //     trxDeadline
    //   )
    //   .send({ from: ownerAddress })
    //   .on("transactionHash", onTransactionHash)
    //   .on("receipt", onReceipt)
    //   .catch(onError);
  };

  const getAllowanceBeforeSwap = async (
    code: string,
    contractAddress: string,
    spender: string,
    account: string,
    inputAmount: string
  ) => {
    const inputAmountWei = ethers.parseEther(inputAmount).toString();
    const amount = BigNumber(inputAmountWei ?? "0");

    const allowance = await getAllowance(
      code,
      account,
      spender,
      contractAddress
    );

    if (allowance) {
      return BigNumber(allowance).isGreaterThanOrEqualTo(amount);
    } else {
      return false;
    }
  };

  const checkAllowanceBeforeSwap = async (
    code: string,
    tokenAddress: string,
    spenderAddress: string,
    account: string,
    inputAmount: string
  ) => {
    const inputAmountWei = ethers.parseEther(inputAmount).toString();
    const amount = BigNumber(inputAmountWei ?? "0");

    const allowance = await getAllowance(
      code,
      account,
      spenderAddress,
      tokenAddress
    );
    if (allowance && BigNumber(allowance).isLessThan(amount)) {
      await approveTokenToSpender(tokenAddress, account, spenderAddress, {
        onTransactionHash: (txHash) => {},
        onReceipt: ({ transactionHash, status }) => {},
          onError: (receipt) => {},
      });
    }
  };

  const swapNativeForExactTokens = async (
    amountOut: string,
    nativeAmount: string,
    tokenAddressInList: string[],
    ownerAddress: string,
    trxDeadline: string,
    poolType: string,
    dmmPoolAddresses: string[],
    { onError = noOp, onReceipt = noOp2, onTransactionHash = noOp1 }
  ) => {
    try {
      const hash = await writeContract(wagmiConfig, {
        abi: AutoRouter,
        value: BigInt(nativeAmount),
        address: autorouteAddress as `0x${string}`,
        functionName: "swapNativeForExactTokens",
        args: [
          BigInt(amountOut),
          tokenAddressInList,
          poolType,
          dmmPoolAddresses,
          ownerAddress as `0x${string}`,
          BigInt(trxDeadline),
        ],
      });

      onTransactionHash(hash);
      
      // Wait for the transaction to be mined
      const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });
      
      onReceipt({ transactionHash: receipt.transactionHash, status: receipt.status === "success" });

      return { transactionHash: receipt.transactionHash, status: receipt.status === "success" };
    } catch (error) {
      onError();
      throw error;
    }
    // await ethereum.contracts.autoRouter.methods
    //   .swapNativeForExactTokens(
    //     amountOut,
    //     tokenAddressInList,
    //     poolType,
    //     dmmPoolAddresses,
    //     ownerAddress,
    //     trxDeadline
    //   )
    //   .send({ from: ownerAddress, value: nativeAmount })
    //   .on("transactionHash", onTransactionHash)
    //   .on("receipt", onReceipt)
    //   .catch(onError);
  };

  const swapTokensForExactNative = async (
    amountOut: string,
    amountInMax: string,
    tokenAddressInList: string[],
    ownerAddress: string,
    trxDeadline: string,
    poolType: string,
    dmmPoolAddresses: string[],
    { onError = noOp, onReceipt = noOp2, onTransactionHash = noOp1 }
  ) => {
    try {
      const hash = await writeContract(wagmiConfig, {
        abi: AutoRouter,
        address: autorouteAddress as `0x${string}`,
        functionName: "swapTokensForExactNative",
        args: [
          BigInt(amountOut),
          BigInt(amountInMax),
          tokenAddressInList,
          poolType,
          dmmPoolAddresses,
          ownerAddress as `0x${string}`,
          BigInt(trxDeadline),
        ],
      });

      onTransactionHash(hash);
      
      // Wait for the transaction to be mined
      const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });
      
      onReceipt({ transactionHash: receipt.transactionHash, status: receipt.status === "success" });
      return { transactionHash: receipt.transactionHash, status: receipt.status === "success" };
    } catch (error) {
      onError();
      throw error;
    }
    // await ethereum.contracts.autoRouter.methods
    //   .swapTokensForExactNative(
    //     amountOut,
    //     amountInMax,
    //     tokenAddressInList,
    //     poolType,
    //     dmmPoolAddresses,
    //     ownerAddress,
    //     trxDeadline
    //   )
    //   .send({ from: ownerAddress })
    //   .on("transactionHash", onTransactionHash)
    //   .on("receipt", onReceipt)
    //   .catch(onError);
  };

  const swapTokensForExactTokens = async (
    amountOut: string,
    amountInMax: string,
    tokenAddressInList: string[],
    ownerAddress: string,
    trxDeadline: string,
    poolType: string,
    dmmPoolAddresses: string[],
    { onError = noOp, onReceipt = noOp2, onTransactionHash = noOp1 }
  ) => {
    try {
      const hash = await writeContract(wagmiConfig, {
        abi: AutoRouter,
        address: autorouteAddress as `0x${string}`,
        functionName: "swapTokensForExactTokens",
        args: [
          BigInt(amountOut),
          BigInt(amountInMax),
          tokenAddressInList,
          poolType,
          dmmPoolAddresses,
          ownerAddress as `0x${string}`,
          BigInt(trxDeadline),
        ],
      });

      onTransactionHash(hash);
      
      // Wait for the transaction to be mined
      const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });
      
      onReceipt({ transactionHash: receipt.transactionHash, status: receipt.status === "success" });
      return { transactionHash: receipt.transactionHash, status: receipt.status === "success" };
    } catch (error) {
      onError();
      throw error;
    }
    // await ethereum.contracts.autoRouter.methods
    //   .swapTokensForExactTokens(
    //     amountOut,
    //     amountInMax,
    //     tokenAddressInList,
    //     poolType,
    //     dmmPoolAddresses,
    //     ownerAddress,
    //     trxDeadline
    //   )
    //   .send({ from: ownerAddress })
    //   .on("transactionHash", onTransactionHash)
    //   .on("receipt", onReceipt)
    //   .catch(onError);
  };

  const getAMPBPS = async (lpName: string) => {
    try {
      const tokenAddress = config.token[lpName]?.address;
      if (!tokenAddress) {
        console.error(`Token address not found for ${lpName}`);
        return "0";
      }
      
      const result = await lazyReadContract(
        ERC20ABI,
        tokenAddress,
        "ampBps",
        []
      );
      return result?.toString() || "0";
    } catch (error) {
      console.error("Error getting AMPBPS:", error);
      return "0";
    }
  };

  return {
    tooltipDynamicFee,
    swapExactNativeForTokens,
    swapExactTokensForNative,
    swapExactTokensForTokens,
    checkAllowanceBeforeSwap,
    getAllowanceBeforeSwap,
    swapNativeForExactTokens,
    swapTokensForExactNative,
    swapTokensForExactTokens,
    getAMPBPS,
  };
};

export default useSwapHelpers;
